import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const imageCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default imageCommands;
